var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlainArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.158 12.416l-5.22 4.072C9.15 17.103 8 16.541 8 15.542v-7.2a1.2 1.2 0 011.901-.973l5.233 3.767a.8.8 0 01.024 1.28z",
    fill: "var(--color-primary)",
    stroke: "var(--color-primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlainArrowRight);
export default __webpack_public_path__ + "static/media/plain-arrow-right.f0a3a964079c143f8ff92ec182dc078f.svg";
export { ForwardRef as ReactComponent };